var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"home"}},[_c('f7-navbar',{attrs:{"title":"Home"}}),_vm._v("\n    home\n\n    "),_c('f7-link',{attrs:{"href":"/login"}},[_vm._v("Login Page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }